<template>
  <div class="forms">
    <v-container fluid>
      <h1>Forms</h1>
      <div class="card-curvey pa-0 delete-wrapper mt-3 pb-2" v-for="(form,index) in forms" :key="index">
        <form-data :form="form"></form-data>

        <v-btn
          @click="deleteForm(index)"
          fab small color=""
          class="delete-button"
        ><v-icon small color="#666">delete_outline</v-icon></v-btn>
      </div>
      <v-btn
        large round flat block
        class="primary--text"
        @click="addForm"
      >
        <v-icon>add_circle_outline</v-icon>
        Add New Form
      </v-btn>
    </v-container>
  </div>
</template>

<script>
  import common from "../../../../utils/common";
  import formData from "./formData";
  export default {
    name: "forms",
    components: {
      formData
    },
    data() {
      return {
        forms: [],
      }
    },
    mounted() {
      this.getForms()
    },
    methods: {
      getForms () {
        this.$store.dispatch('setLoader',true)
        this.$http_bot.get('bot_objects/forms')
        .then(response=> {
          this.forms = response.data
          this.$store.dispatch('setLoader',false)
        })
        .catch(error=>{
          this.$store.dispatch('setLoader',false)
          if (error.response && error.response.status === 401) {
            common.logOut()
          } else {
            this.$store.dispatch('setErrorMessage', true)
          }
        })
      },
      addForm () {
        this.$store.dispatch('setSavingStatus',true)
        this.$http.post('/bot_objects/forms',{
          bot_id: this.$store.state.bot.botId,
          active: true,
          body: {
            name: '',
            label: '',
            locale: '',
            inputs: [
              {
                type: 'textfield',
                label: '',
                key: '',
                required: true,
                regex: '',
                errorMessage: '',
              }
            ]
          }
        })
        .then(response=> {
          this.forms.push(response.data)
        })
        .catch(error=>{
          this.$store.dispatch('setLoader',false)
          if (error.response && error.response.status === 401) {
            common.logOut()
          } else {
            this.$store.dispatch('setErrorMessage', true)
          }
        })
      },
      deleteForm(index) {
        this.$store.dispatch('setSavingStatus',true)
        this.$http.delete(`/bot_objects/forms/${this.forms[index].id}`)
        .then(()=>{
          this.forms.splice(index,1)
          this.$store.dispatch('setSavingStatus',false)
        })
        .catch(error=>{
          this.$store.dispatch('setLoader',false)
          if (error.response && error.response.status === 401) {
            common.logOut()
          } else {
            this.$store.dispatch('setErrorMessage', false)
          }
        })
      },
    }
  }
</script>

<style scoped>

</style>
